/**
 * Created by or_p on 5/30/2016.
 */
import {TweenMax} from 'gsap'; // eslint-disable-line no-unused-vars
/* global Linear Bounce Back SlowMo Ease TimelineLite TweenLite */

export function getAttentionAnimation(selector, axis = 'y', factor = 1) {
  const timeline = new TimelineLite();
  timeline.to(selector, 0.15,
    {
      [axis]: `${10 * factor}px`,
      ease: Ease.easeInOut
    }
  ).to(selector, 0.075,
    {
      [axis]: `${-10 * factor}px`,
      ease: Ease.easeInOut
    }
  ).to(selector, 0.075,
    {
      [axis]: `${5 * factor}px`,
      ease: Ease.easeInOut
    }
  ).to(selector, 0.075,
    {
      [axis]: '0px',
      ease: Back.easeOut
    }
  );
}
